import fastdom from 'fastdom';
import { onArticleSearchResultsLoaded$, onloadingArticleSearchResults$ } from 'features/articleSearchResultsFacets';


const LISTING_SECTION_SELECTOR = '[data-author-articles]';
const LISTING_CONTAINER_SELECTOR = '[data-author-article-list]';

/**
 * Scroll to the top of the article container when we render
 * new cards
 */
function scrollToTopPage() {
  const container = document.querySelector(LISTING_SECTION_SELECTOR);
  if (container) {
    container.scrollIntoView({ behavior: 'smooth' });
  }
}

/**
 * displays the new article cards
 * @param htmlResponse
 */
function renderArticleResults(htmlResponse) {
  const articlesContainer = document.querySelector(LISTING_CONTAINER_SELECTOR);
  if (!articlesContainer) {
    return;
  }

  fastdom.mutate(() => {
    articlesContainer.innerHTML = htmlResponse;
    if (!htmlResponse) {
      articlesContainer.setAttribute('hidden', '');
    }
  });
}

// Subscribe to the observables to trigger the scroll and render functions
onloadingArticleSearchResults$.subscribe(scrollToTopPage);
onArticleSearchResultsLoaded$.subscribe(renderArticleResults);
